// Visibility only. The independent server policy enforces every paid operation.
export const HOME_SMART_EMAIL_ONLY = true;